import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {IconButton} from "@mui/material";
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {useModelContext} from "@app/contexts/model";
import {faWindowClose} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


interface IHideWordProps {
}


export const HideWord: FunctionComponent<IHideWordProps> = observer<FunctionComponent<IHideWordProps>>(function (props) {

    const {translateStore} = useStorageTranslateContext()
    const {languageFileModel} = useModelContext()

    let dataLanguageResponse = languageFileModel.dataLanguage.get()

    let disabled = !dataLanguageResponse;


    return <IconButton
            disabled={disabled}
            className={translateStore.hideWords ? "featureButtons__i--active" : "featureButtons__i"}
            aria-hidden="true"
            title={translateStore.hideWords ? "Show all words" : "Show every untranslated word" }
            onClick={() => {
                translateStore.changeWords = false
                translateStore.hideWords = !translateStore.hideWords;
                translateStore.gridApi.onFilterChanged();
                translateStore.filteredSet.clear()
            }}
    >
        <FontAwesomeIcon icon={faWindowClose}/>
    </IconButton>
});

